import React, { Fragment, useState, useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { useEvaluationActions } from "@_recoil/_actions";
import { evaluationAtom } from "@_recoil/_state";
import { swalError } from "@unisearch/helpers";
import { getExamPoint } from "@unisearch/helpers";

import styles from "./evaluation_exam.module.scss";

const EvaluationExam = () => {
  const { exams, is_loading } = useRecoilValue(evaluationAtom);

  const [{ courseExam }, setCourseExam] = useRecoilState(evaluationAtom);
  const [examState, setExamState] = useState(courseExam);

  const [error, setError] = useState(false);

  // const [showItems, setShowItem] = useState([]);

  //handle points
  const handlePoints = (event, examId, min, max) => {
    const { name, value } = event.target;

    let examArr = [...examState];
    let exindex = examArr.findIndex(
      (item) => parseInt(item.examId) == parseInt(examId)
    );

    if (parseFloat(value) > max) {
      swalError(`Sorry! Input point can input between ${min}  and ${max}`);
      let obj = { ...examArr[exindex], point: "" };
      examArr[exindex] = obj;
      setExamState(examArr);
      setError(true);
    } else {
      let obj = { ...examArr[exindex], point: value };
      examArr[exindex] = obj;
      setExamState(examArr);
      setError(false);
    }
  };

  //validation with min value
  const handleBlur = (event, examId, min, max) => {
    const { name, value } = event.target;
    let examArr = [...examState];
    let exindex = examArr.findIndex(
      (item) => parseInt(item.examId) == parseInt(examId)
    );

    if (parseFloat(value) < min) {
      swalError(`Sorry! Input point can input between ${min}  and ${max}`);
      let obj = { ...examArr[exindex], point: "" };
      examArr[exindex] = obj;
      setExamState(examArr);
      setError(true);
    }
  };

  //handle exam change
  const handleExam = (event) => {
    //get target value
    const { value, checked } = event.target;

    //when unchecked remove form selected
    if (!checked) {
      setExamState(
        examState.filter((ex) => parseInt(ex.examId) != parseInt(value))
      );

      //hide exampoints
      // setShowItem(
      //   showItems.filter((exid) => parseInt(exid) != parseInt(value))
      // );

      return false;
    }

    if (checked) {
      let examobj = { examId: parseInt(value), point: "" };
      setExamState((prev) => [...prev, examobj]);

      //hide exampoints
      // setShowItem((prev) => [...prev, parseInt(value)]);
    }
  };

  useEffect(() => {
    setCourseExam((prev) => ({
      ...prev,
      courseExam: examState,
    }));
  }, [examState]);

  const isChecked = (id) => {
    let sitem = courseExam.filter((item) => {
      if (parseInt(item.examId) == parseInt(id)) {
        return true;
      } else {
        return false;
      }
    });
    return sitem.length ? true : false;
  };

  const printValue = (examId) => {
    const selExam = courseExam.filter((item) => {
      return parseInt(item.examId) == parseInt(examId);
    });
    return selExam[0].point ?? "";
  };

  const notyetExam = () => {
    setExamState([]);
    setCourseExam((prev) => ({
      ...prev,
      show_next: true,
    }));
  };

  //set error
  useEffect(() => {
    if (courseExam.length) {
      let ErrorExam = Object.values(examState).filter(
        (ex) => ex.examId == "" || ex.point == ""
      );

      setCourseExam((prev) => ({
        ...prev,
        show_next: ErrorExam.length ? false : true,
      }));
    } else if (courseExam.length == 0) {
      setCourseExam((prev) => ({
        ...prev,
        show_next: true,
      }));
    } else {
      setCourseExam((prev) => ({
        ...prev,
        show_next: false,
      }));
    }
  }, [courseExam]);

  return (
    <Fragment>
      <div className={styles.title_wrapper}>
        <div className={styles.title}>
          Which English Proficiency Exam Have You Taken/Do You Plan to Take?
        </div>
      </div>
      <div className={styles.content}>
        <ul>
          {exams &&
            exams.map((exm, index) => {
              if (
                exm.slug.toLowerCase() != "gmat" &&
                exm.slug.toLowerCase() != "gre"
              ) {
                return (
                  <li key={`${exm.examId}_${exm.slug}`}>
                    <label
                      htmlFor={`${exm.examId}_${exm.slug}`}
                      className={isChecked(exm.examId) ? styles.active : ""}
                    >
                      <input
                        style={{ display: "none" }}
                        type="checkbox"
                        id={`${exm.examId}_${exm.slug}`}
                        name="examId"
                        value={exm.examId}
                        checked={isChecked(exm.examId)}
                        onChange={handleExam}
                      />
                      <div className={styles.name}>{exm?.examName}</div>
                    </label>

                    {isChecked(exm.examId) && (
                      <div className={styles.exam_form_group}>
                        <h5>
                          {`Enter Marks Between  ${exm.minExamPoint} and  ${exm.maxExamPoint}`}
                        </h5>
                        <input
                          onBlur={(event) =>
                            handleBlur(
                              event,
                              exm.examId,
                              exm.minExamPoint,
                              exm.maxExamPoint
                            )
                          }
                          onChange={(event) =>
                            handlePoints(
                              event,
                              exm.examId,
                              exm.minExamPoint,
                              exm.maxExamPoint
                            )
                          }
                          type="number"
                          name="point"
                          placeholder="Achieved Marks"
                          value={printValue(exm.examId)}
                        />
                      </div>
                    )}
                  </li>
                );
              }
            })}
        </ul>
        <div className={styles.exam_form_wrapper}>
          <button
            onClick={notyetExam}
            className={` ${styles.exam_skip_btn}  ${
              courseExam.length == 0 ? styles.active : ""
            } `}
          >
            I Have Not Taken Any Exams Yet
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default EvaluationExam;
